/**
 * Utility functions
 * Helper functions for device detection and common utilities
 */

export function isMobile() {
  return window.innerWidth <= 992;
}

export function isTab() {
  return window.innerWidth > 992 && window.innerWidth <= 1280;
}

export function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export function throttle(func, limit) {
  let inThrottle;
  return function(...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}
